var app = angular.module("leonardo");

var OwnerTasksStates = function($stateProvider) {
  $stateProvider.state('owner-tasks', {
    url: '/owner-action-items',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'owner-tasks.tasks',
    ncyBreadcrumb: {
      label: 'Owner action items'
    }
  });

  $stateProvider.state('owner-tasks.tasks', {
    url: "/tasks",
    title: 'Tasks overview',
    taskMode: 'owner',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/owner-tasks/tasks.html',
        controller: 'PropertyTasks'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'PropertyTasksFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/tasks-list.html',
        controller: 'TaskActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Tasks overview'
    }
  });

  $stateProvider.state('owner-tasks.past-due', {
    url: "/past-due",
    title: 'Past due',
    taskMode: 'owner',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/property/past-due.html',
        controller: 'PropertyTasks'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'PropertyTasksFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/tasks-list.html',
        controller: 'TaskActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Past due'
    }
  });
};

app.config(['$stateProvider', OwnerTasksStates]);
